import { NgFor } from '@angular/common';
import { Component, EventEmitter, HostBinding, Output } from '@angular/core';
import { UIIcon } from '../../../icon';
import {
  ITableActionsColumn,
  ITableActionsColumnDetails,
  TableActionsColumnType,
} from '../../models';
import { UITableBaseColumn } from '../table-base-column/table-base-column.component';
@Component({
  selector: 'ui-table-body-actions-column',
  templateUrl: './table-body-actions-column.component.html',
  styleUrls: ['./table-body-actions-column.component.scss'],
  standalone: true,
  imports: [NgFor, UIIcon],
})
export class UITableBodyActionsColumn extends UITableBaseColumn {
  @Output() actionClicked = new EventEmitter<TableActionsColumnType>();

  @HostBinding('style.width') override get columnWidth() {
    return 'auto';
  }

  @HostBinding('style.justify-content')
  get alignContent() {
    return this.config?.align ?? 'right';
  }

  get buttons(): ITableActionsColumnDetails[] {
    return ((this.config as ITableActionsColumn)?.buttons ?? [])
      .filter((btn) => !btn.hideCondition || !btn.hideCondition(this.data))
      .map((btn) => {
        const icon =
          btn.type === 'edit'
            ? 'form'
            : btn.type === 'details'
            ? 'file-text'
            : btn.type === 'delete'
            ? 'delete'
            : undefined;
        const color = btn.type === 'delete' ? '#e02523' : undefined;
        return {
          ...btn,
          icon: btn.icon || icon,
          color: btn.color || color,
        };
      });
  }

  onActionClicked(action: ITableActionsColumnDetails): void {
    this.actionClicked.emit(action.type);
  }

  trackById(index: number, item: any) {
    return item && item['type'] + index;
  }
}
